import { FormGroup } from '@angular/forms';

/**
 * Report actions can be triggered by search, print, or export buttons outside
 * the form. Mark controls touched before rejecting an invalid request so every
 * Astral control exposes its existing validation message consistently.
 */
export function canSubmitReportForm(form: FormGroup): boolean {
  if (form.valid) return true;

  form.markAllAsTouched();
  return false;
}
